var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5199 9.57349C18.5199 9.57349 17.9995 16.0279 17.6976 18.7467C17.5539 20.0452 16.7518 20.8061 15.4379 20.8301C12.9376 20.8751 10.4344 20.878 7.93508 20.8253C6.67104 20.7994 5.88233 20.0289 5.74146 18.7534C5.43767 16.0106 4.92017 9.57349 4.92017 9.57349",
    stroke: "white",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8457 6.47966H3.59424",
    stroke: "white",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7143 6.47961C15.962 6.47961 15.3142 5.94774 15.1666 5.21078L14.9337 4.04544C14.79 3.50782 14.3031 3.13599 13.7483 3.13599H9.69163C9.13675 3.13599 8.64992 3.50782 8.50617 4.04544L8.27329 5.21078C8.12571 5.94774 7.47788 6.47961 6.72559 6.47961",
    stroke: "white",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.95259ea31806eee740b93d0cefc40213.svg";
export { ForwardRef as ReactComponent };